import { useParams, usePathname } from 'next/navigation'
import { useEffect, useMemo } from 'react'

import { catalogBannerApiSlice } from '../api/catalog-banner-api'

const BLOCKED_SLUG_LIST = [`filter`]

export const useCatalogBanner = () => {
	const pathname = usePathname()
	const params = useParams()
	const [fetchBannerData, { isLoading, currentData }] = catalogBannerApiSlice.useLazyGetCatalogBannersQuery()

	const topBanner = useMemo(() => {
		if (!currentData) return null
		return {
			src: currentData?.UF_CATALOG_BANNER,
			link: currentData?.UF_CATALOG_BANNER_LINK,
			id: currentData?.UF_CATALOG_BANNER_ID,
			name: currentData?.UF_CATALOG_BANNER_NAME,
			mobSrc: currentData?.UF_CATALOG_BANNER_MOBILE
		}
	}, [currentData])
	const middleBanner = useMemo(() => {
		if (!currentData) return null
		return {
			src: currentData?.UF_CATALOG_MIDDLE_BANNER,
			link: currentData?.UF_CATALOG_BANNER_MIDDLE_LINK,
			id: currentData?.UF_CATALOG_BANNER_MIDDLE_ID,
			name: currentData?.UF_CATALOG_BANNER_MIDDLE_NAME,
			mobSrc: currentData?.UF_CATALOG_BANNER_MIDDLE_MOBILE
		}
	}, [currentData])

	useEffect(() => {
		const rawSlug = params.slug
		const slugList = (Array.isArray(rawSlug) ? rawSlug : rawSlug ? [rawSlug] : []) as string[]
		const [main, child] = slugList.filter(item => !BLOCKED_SLUG_LIST.includes(item))

		getBannerData(main, child)
	}, [pathname])

	const getBannerData = async (mainCategory: string, childCategory: string) => {
		await fetchBannerData({ mainCategory, childCategory }, true)
	}

	return {
		isLoading,
		isHidden: topBanner?.src || middleBanner?.src ? currentData?.UF_CATALOG_IS_HIDDEN_BANNER : true,
		topBanner,
		middleBanner
	}
}
